/* nv-bundle.js : 28/10/2026. Bloc d'offres natif (remplace l'app Moonbundle + nv-moon.js sur la page produit).
   Markup : snippets/nv-bundle.liquid. Styles : assets/nv-bundle.css.
   Regles reprises de nv-moon.js (05/10 au 21/10) :
   1) un seul lot dans le panier : avant chaque ajout on retire les reggiseni et les cadeaux de lot deja presents ;
   2) un seul appel POST /cart/add.js par tap (un seul evenement AddToCart pour le pixel Meta), jamais d'envoi de formulaire ;
   3) taille obligatoire pour chaque piece, message « Scegli la taglia per ogni reggiseno » ;
   4) la grande photo suit la derniere couleur choisie ; la vignette de chaque piece suit sa couleur ;
   5) la culotte offerte (palier 4) prend la taille (et si possible la couleur) du reggiseno n°1 ;
   6) la barre collante affiche le prix et le nombre de pieces de l'offre cochee, et se cache tant que le bloc est a l'ecran ;
   7) compatibilite quiz / bloc « Scegli la tua taglia » : select.rapi_option_mb, data-nv-ok, window.__nvMbSize, data-nv-atc-start. */
(function () {
  if (window.__nvBundle) return; window.__nvBundle = true;
  var SIZES = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  var setVal = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  function fire(s, n) { s.dispatchEvent(new Event(n || 'change', { bubbles: true })); }
  function root() { return $('nv-bundle[data-nv-bundle]'); }
  function opts() { return $$('nv-bundle .moonbundle-option'); }
  function active() { return $('nv-bundle .moonbundle-option.moonbundle-option-active'); }
  function handle() { var r = root(); return (r && r.getAttribute('data-handle')) || 'reggiseno-comfort-nuvella'; }

  /* ---- variantes : { "Couleur / Taille": [id, dispo] } ---- */
  var VAR = null;
  function variants() {
    if (VAR) return VAR;
    try { VAR = JSON.parse(($('nv-bundle [data-nv-variants]') || {}).textContent || '{}'); } catch (e) { VAR = {}; }
    return VAR;
  }
  function vid(c, s) { var v = variants()[c + ' / ' + s]; return v ? v[0] : 0; }
  function avail(c, s) { var v = variants()[c + ' / ' + s]; return !!(v && v[1]); }

  /* ---- photos : carte couleur -> image (pastilles du theme, puis #nv-color-map) ---- */
  var IMG = null;
  function colorMap() {
    if (IMG) return IMG;
    var m = {}, n = 0;
    $$('[data-mdr-optgroup="color"] [data-mdr-optvalue]').forEach(function (b) {
      var i = b.querySelector('img'); if (i && (i.currentSrc || i.src)) { m[b.getAttribute('data-value')] = i.currentSrc || i.src; n++; }
    });
    if (!n) { try { var j = JSON.parse(($('#nv-color-map') || {}).textContent || '{}'); Object.keys(j).forEach(function (k) { m[k] = j[k]; n++; }); } catch (e) {} }
    if (n) IMG = m;
    return m;
  }
  function sized(u, w) { if (!u) return u; return /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, '$1' + w) : u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  var PRE = {};
  function pre(c) { var u = colorMap()[c]; if (!u || PRE[c]) return; PRE[c] = 1; var a = new Image(); a.src = sized(u, 900); var b = new Image(); b.src = sized(u, 120); }
  function preloadAll() { var m = colorMap(); Object.keys(m).forEach(pre); }
  function showColor(c) {
    var u = colorMap()[c]; if (!u) return;
    var main = $('[data-mdr-main] img'); if (!main) return;
    var big = sized(u, 900); if (main.getAttribute('src') === big) return;
    var im = new Image(); im.src = big;
    var swap = function () { main.removeAttribute('srcset'); main.src = big; };
    if (im.decode) im.decode().then(swap, swap); else swap();
  }
  function thumb(row) {
    var c = $('[data-nv-color]', row), img = $('img.moonbundle-variant-image', row), u = c && colorMap()[c.value];
    if (!img || !u) return;
    var t = sized(u, 120); if (img.getAttribute('src') !== t) img.src = t;
  }

  /* ---- tailles : placeholder « Taglia » tant que la cliente n'a pas choisi, dispo par couleur ---- */
  function sizeSels(scope) { return $$('select[data-nv-size]', scope || root()); }
  /* 29/10 : le placeholder « Taglia » est une vraie <option> (plus de calque ni de manipulation au focus : double tap iOS) */
  /* calque de texte : ce que la cliente voit ne depend plus du rendu natif du <select> (vide sur iOS dans certains cas) */
  function paintPh(sel) {
    var ph = sel.parentNode && sel.parentNode.querySelector('[data-nv-ph]'); if (!ph) return;
    var o = sel.options[sel.selectedIndex], txt = sel.value && o ? o.text.trim() : (sel.hasAttribute('data-nv-size') ? 'Taglia' : '');
    if (ph.textContent !== txt) ph.textContent = txt;
  }
  function paintSize(s) { s.classList.toggle('nv-size-unset', !s.value); if (s.value && !s.hasAttribute('data-nv-ok')) s.setAttribute('data-nv-ok', '1'); paintPh(s); }
  function refreshSizes(row) {
    var c = $('[data-nv-color]', row), s = $('[data-nv-size]', row); if (!c || !s) return;
    [].forEach.call(s.options, function (o) { if (!o.value) return; var ok = avail(c.value, o.value); o.disabled = !ok; o.hidden = !ok; });
    if (s.value && !avail(c.value, s.value)) { setVal.call(s, ''); s.removeAttribute('data-nv-ok'); s.classList.add('nv-size-need'); }
  }
  function missing() {
    var a = active(); if (!a) return [];
    return sizeSels(a).filter(function (s) { return s.offsetParent && !s.value; });
  }
  function clearErr() {
    if (missing().length) return;
    var err = $('nv-bundle .nv-mb-err'); if (err) err.remove();
    var sq = $('[data-nv-sq]'); if (sq) sq.classList.remove('nv-sq--need');
  }

  /* ---- cadeau culotte : suit la taille (et la couleur si elle existe) du reggiseno n°1, tant que la cliente n'y a pas touche ---- */
  var GJ = {};
  function giftJson(sel) { if (GJ[sel]) return GJ[sel]; try { GJ[sel] = JSON.parse(($(sel) || {}).textContent || '{}'); } catch (e) { GJ[sel] = {}; } return GJ[sel]; }
  function giftImg(g) {
    var s = $('[data-nv-gift-variant]', g), img = $('[data-nv-gift-img]', g); if (!s || !img) return;
    var src = giftJson('[data-nv-gift-images]')[(s.value || '').split(' / ')[0]]; if (src && img.getAttribute('src') !== src) img.src = src;
  }
  function giftVid(g) {
    var s = $('[data-nv-gift-variant]', g); if (!s) return 0;
    var map = giftJson('[data-nv-gift-variants]'), v = map[s.value]; if (v && v[1]) return v[0];
    var size = (s.value || '').split(' / ').pop(), alt = 0;
    Object.keys(map).forEach(function (k) { if (!alt && map[k][1] && k.split(' / ').pop() === size) alt = map[k][0]; });
    if (!alt) Object.keys(map).forEach(function (k) { if (!alt && map[k][1]) alt = map[k][0]; });
    return alt;
  }
  function syncGift() {
    var a = active(); if (!a) return;
    var g = $('[data-nv-gift="cul"]', a); if (!g) return;
    var sz = sizeSels(a)[0], col = $('[data-nv-color]', a), gs = $('[data-nv-gift-variant]', g); if (!gs) return;
    if (!g.hasAttribute('data-nv-touched') && sz && sz.hasAttribute('data-nv-ok')) {
      var c = col ? col.value : '', want = null;
      [].forEach.call(gs.options, function (o) { if (!want && !o.disabled && o.value === c + ' / ' + sz.value) want = o.value; });
      [].forEach.call(gs.options, function (o) { if (!want && !o.disabled && o.value.split(' / ').pop() === sz.value) want = o.value; });
      if (want && gs.value !== want) setVal.call(gs, want);
    }
    giftImg(g);
  }

  /* ---- barre collante : prix + pieces de l'offre cochee ---- */
  function syncSticky() {
    var bar = $('[data-mdr-sticky]'), a = active(); if (!bar || !a) return;
    var pe = bar.querySelector('[data-mdr-sticky-price]'), ne = bar.querySelector('.mdr-sticky__price small');
    var sp = a.querySelector('.moonbundle-option-single-price'), m = sp && (sp.textContent || '').match(/(\d+[.,]\d{2})/);
    if (pe && m) { var t = m[1].replace('.', ',') + ' €'; if (pe.textContent !== t) pe.textContent = t; }
    var n = +a.getAttribute('data-qty');
    if (n && ne) { var nt = n + (n > 1 ? ' reggiseni' : ' reggiseno') + ' · spedizione gratuita'; if (ne.textContent !== nt) ne.textContent = nt; }
  }
  function stickyGuard(n) {
    var bar = $('[data-mdr-sticky]'), r = root();
    if (!bar || !r || !('IntersectionObserver' in window)) { if (n < 40) setTimeout(function () { stickyGuard(n + 1); }, 500); return; }
    new IntersectionObserver(function (es) { var on = es[es.length - 1].isIntersecting; bar.classList.toggle('nv-off', on); if (on) bar.setAttribute('aria-hidden', 'true'); }, { threshold: 0 }).observe(r);
  }

  /* ---- choix d'une offre ---- */
  function select(o) {
    if (!o) return;
    opts().forEach(function (x) {
      var on = x === o; x.classList.toggle('moonbundle-option-active', on); x.setAttribute('aria-checked', on ? 'true' : 'false');
      var rows = $('[data-nv-rows]', x); if (rows) rows.hidden = !on;
    });
    /* le bloc « Scegli la tua taglia » vit dans l'offre cochee, au-dessus des menus (comme sous Moonbundle) */
    var sq = $('[data-nv-sq]'), vb = $('[data-nv-rows]', o);
    if (sq && vb && sq.nextElementSibling !== vb) vb.parentNode.insertBefore(sq, vb);
    $$('[data-nv-row]', o).forEach(function (row) { refreshSizes(row); thumb(row); var cs = $('[data-nv-color]', row); if (cs) paintPh(cs); });
    sizeSels(o).forEach(function (s) { if (window.__nvMbSize && !s.hasAttribute('data-nv-ok') && avail($('[data-nv-color]', s.closest('[data-nv-row]')).value, window.__nvMbSize)) { setVal.call(s, window.__nvMbSize); s.setAttribute('data-nv-ok', '1'); } paintSize(s); });
    syncGift(); syncSticky();
  }

  /* ---- ajout au panier : un seul lot, un seul appel ---- */
  function started(b) { try { window.__nvAddT = Date.now(); b.setAttribute('data-nv-atc-start', String(window.__nvAddT)); } catch (x) {} }
  function payload() {
    var a = active(); if (!a) return null;
    var lot = a.getAttribute('data-label'), by = {}, order = [];
    $$('[data-nv-row]', a).forEach(function (row) {
      var c = $('[data-nv-color]', row).value, s = $('[data-nv-size]', row).value, id = vid(c, s);
      if (!id) return;
      if (!by[id]) { by[id] = { id: id, quantity: 0, properties: { _nv_offerta: lot } }; order.push(id); }
      by[id].quantity++;
    });
    var items = order.map(function (id) { return by[id]; }), n = 0;
    items.forEach(function (i) { n += i.quantity; });
    if (!items.length || n !== $$('[data-nv-row]', a).length) return null;
    $$('[data-nv-gift]', a).forEach(function (g) {
      var id = g.getAttribute('data-nv-gift') === 'cul' ? giftVid(g) : +g.getAttribute('data-vid');
      if (id) items.push({ id: id, quantity: 1, properties: { _nv_offerta: lot, _nv_regalo: '1' } });
    });
    return { items: items };
  }
  function post(url, body, ctrl) {
    return window.fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), signal: ctrl ? ctrl.signal : undefined });
  }
  function isLotLine(i) { var p = i.properties || {}; return i.handle === handle() || p._nv_regalo || /-in-regalo$/.test(i.handle || ''); }
  function oldFromApi() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      return (c.items || []).filter(isLotLine).map(function (i) { var p = i.properties || {}; return { v: i.variant_id, q: i.quantity, o: p._nv_offerta || '', l: p._nv_lot || '', g: p._nv_regalo ? 1 : 0 }; });
    });
  }
  function oldLines() {
    var fresh = window.nvCart && window.nvCart.itemsAge && window.nvCart.itemsAge() < 30000, known = fresh ? window.nvCart.items() : null, h = handle();
    if (known) return Promise.resolve(known.filter(function (i) { return i.h === h || i.g; }).map(function (i) { return { v: i.v, q: i.q || 1, o: i.o || '', l: i.l || '', g: i.g ? 1 : 0 }; }));
    return oldFromApi();
  }
  /* retrait par IDENTIFIANT DE VARIANTE : /cart/update.js lit une cle de ligne comme une variante et vise la 1re ligne de cette variante (vu le 29/10) ;
     a ce moment seules les lignes de l'ancien lot existent pour ces variantes, donc le retrait par variante est exact */
  function removeLines(lines, ctrl) {
    var u = {}; lines.forEach(function (i) { if (i.v) u[String(i.v)] = 0; });
    if (!Object.keys(u).length) return Promise.resolve();
    return post('/cart/update.js', { updates: u }, ctrl).then(function (r) { if (!r.ok) throw new Error('update'); });
  }
  function restoreLines(lines) {
    var items = lines.filter(function (i) { return i.v && i.q; }).map(function (i) { var pr = {}; if (i.o) pr._nv_offerta = i.o; if (i.l) pr._nv_lot = i.l; if (i.g) pr._nv_regalo = '1'; return { id: +i.v, quantity: i.q, properties: pr }; });
    if (!items.length) return Promise.resolve();
    return post('/cart/add.js', { items: items }).catch(function () {});
  }
  function resetBtn(b) { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); if (window.__nvLabel && /Aggiungo/.test(b.textContent)) b.textContent = window.__nvLabel; }
  function add(b) {
    if (window.__nvAdding && Date.now() - window.__nvAdding < 15000) return;
    var body = payload(); if (!body) { toast('Seleziona colore e taglia per ogni reggiseno.'); return; }
    var lot = String(Date.now()); body.items.forEach(function (i) { i.properties._nv_lot = lot; });
    window.__nvAdding = Date.now(); started(b); b.classList.add('is-busy');
    if (!window.__nvLabel) window.__nvLabel = b.textContent; b.setAttribute('aria-busy', 'true'); b.textContent = 'Aggiungo al carrello…';
    try { if (window.nvCart && window.nvCart.openNow) window.nvCart.openNow(); } catch (e) {}
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null, tm = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : null;
    var hadCart = /(?:^|;\s*)cart=/.test(document.cookie), old = [];
    var done = function () { window.__nvAdding = 0; if (tm) clearTimeout(tm); resetBtn(b); try { b.setAttribute('data-nv-add-response-ms', String(Date.now() - (window.__nvAddT || Date.now()))); window.__nvAddT = 0; } catch (x) {} };
    var fail = function (msg) { done(); try { window.nvCart && window.nvCart.close && window.nvCart.close(); } catch (e) {} toast(msg || 'Non è stato possibile aggiungere il prodotto. Riprova.'); };
    /* 1) retrait de l'ancien lot (une requete, zero si panier vide) ; 2) UN SEUL POST /cart/add.js = un seul AddToCart, le tiroir arrive dans la reponse ; 3) echec = ancien lot remis */
    var step1 = hadCart ? oldLines().then(function (lines) { old = lines; return lines.length ? removeLines(lines, ctrl) : null; }).catch(function () {}) : Promise.resolve();
    step1.then(function () {
      return post('/cart/add.js', Object.assign({ sections: 'cart-drawer' }, body), ctrl);
    }).then(function (r) {
      if (!r.ok) { return r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.description || j.message || 'add'); }); }
      return r.json();
    }).then(function (j) {
      done();
      if (j && j.sections && j.sections['cart-drawer'] && window.nvCart && window.nvCart.refreshFromHtml) window.nvCart.refreshFromHtml(j.sections['cart-drawer'], true); else if (window.nvCart) window.nvCart.refresh(true);
    }).catch(function (e) {
      var msg = e && e.name === 'AbortError' ? 'La rete non risponde. Riprova.' : (e && e.message && e.message.length < 120 && !/^(add|update)$/.test(e.message) ? e.message : null);
      restoreLines(old).then(function () { fail(msg); if (window.nvCart) window.nvCart.refresh(false); });
    });
  }
  function toast(t) { var e = document.createElement('div'); e.className = 'nv-toast'; e.textContent = t; document.body.appendChild(e); setTimeout(function () { e.remove(); }, 3500); }
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) { window.__nvAdding = 0; var b = $('.mdr-form .mdr-atc'); if (b) resetBtn(b); } });

  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.mdr-atc'); if (!b || !root()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var m = missing();
    if (!m.length) { add(b); return; }
    m.forEach(function (s) { s.classList.add('nv-mb-need'); s.classList.add('nv-size-need'); });
    var sq = $('[data-nv-sq]'); if (sq) sq.classList.add('nv-sq--need');
    var a = active();
    if (a && !a.querySelector('.nv-mb-err')) {
      var p = document.createElement('p'); p.className = 'nv-mb-err'; p.setAttribute('role', 'alert'); p.textContent = 'Scegli la taglia per ogni reggiseno, poi aggiungi al carrello.';
      var vb = a.querySelector('[data-nv-rows]'); (vb || a).appendChild(p);
    }
    (sq || m[0]).scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);
  /* le formulaire ne doit jamais partir en navigation (Entree dans un champ) */
  document.addEventListener('submit', function (e) { var f = e.target; if (f && f.classList && f.classList.contains('mdr-form') && root()) { e.preventDefault(); e.stopImmediatePropagation(); var b = $('.mdr-form .mdr-atc'); if (b) b.click(); } }, true);

  /* ---- evenements du bloc ---- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('nv-bundle .moonbundle-option'); if (!o) return;
    if (e.target.closest('select, button, a, label, [data-nv-sq]')) return;
    if (!o.classList.contains('moonbundle-option-active')) select(o);
  });
  document.addEventListener('keydown', function (e) {
    var o = e.target && e.target.matches && e.target.matches('nv-bundle .moonbundle-option') ? e.target : null;
    if (o && (e.key === ' ' || e.key === 'Enter')) { e.preventDefault(); select(o); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.matches) return;
    if (e.isTrusted && t.matches('nv-bundle select') && /iP(hone|ad|od)/.test(navigator.userAgent)) setTimeout(function () { try { t.blur(); } catch (x) {} }, 30);
    if (t.matches('nv-bundle [data-nv-color]')) { var row = t.closest('[data-nv-row]'); paintPh(t); window.__nvMbColor = t.value; showColor(t.value); thumb(row); refreshSizes(row); paintSize($('[data-nv-size]', row)); syncGift(); }
    if (t.matches('nv-bundle [data-nv-gift-variant]')) { var gg = t.closest('[data-nv-gift]'); if (e.isTrusted) gg.setAttribute('data-nv-touched', '1'); giftImg(gg); }
    if (t.matches('nv-bundle [data-nv-size]')) {
      if (t.value) {
        t.setAttribute('data-nv-ok', '1'); t.classList.remove('nv-mb-need'); t.classList.remove('nv-size-need'); window.__nvMbSize = t.value;
        /* 29/10 (demande Ilyes) : la taille choisie se propage aux pieces qui n'en ont pas encore (jamais a celles deja choisies) */
        var a0 = t.closest('.moonbundle-option') || active();
        if (a0) sizeSels(a0).forEach(function (s2) {
          if (s2 === t || s2.value) return;
          var c2 = $('[data-nv-color]', s2.closest('[data-nv-row]'));
          if (c2 && avail(c2.value, t.value)) { setVal.call(s2, t.value); s2.setAttribute('data-nv-ok', '1'); s2.classList.remove('nv-mb-need'); s2.classList.remove('nv-size-need'); paintSize(s2); }
        });
      }
      paintSize(t); clearErr(); syncGift();
    }
  }, true);

  function init() {
    var r = root(); if (!r || r.__nvInit) return; r.__nvInit = true;
    /* le bouton du formulaire doit rester un bouton (plus de clone de formulaire : un seul ajout, un seul evenement) */
    $$('[data-nv-row]', r).forEach(function (row) { thumb(row); var cs = $('[data-nv-color]', row), ss = $('[data-nv-size]', row); if (cs) paintPh(cs); if (ss) paintPh(ss); });
    var o = active() || opts()[+r.getAttribute('data-default') || 0];
    select(o);
    stickyGuard(0);
    var sq = $('[data-nv-sq]'); if (sq) { sq.addEventListener('click', function (e) { e.stopPropagation(); }); }
    var idle = window.requestIdleCallback || function (f) { setTimeout(f, 1500); }; idle(preloadAll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.nvBundle = { select: select, missing: missing, payload: payload };
})();
